import { paramParsers } from './param-parsers';
const querySingleParam = (parser) => ({
    set(url, key, val) {
        if (val === undefined || val === null) {
            return;
        }
        const query = parser.stringify(val);
        if (query !== undefined) {
            url.append(key, query);
        }
    },
    get(url, key) {
        const param = url.get(key);
        if (!param) {
            return;
        }
        return parser.parse(param);
    },
});
const queryArrayParam = (parser) => ({
    set(url, key, val) {
        if (val === undefined || val === null || !Array.isArray(val) || !val.length) {
            return;
        }
        val.forEach(item => {
            const query = parser.stringify(item);
            if (query !== undefined) {
                url.append(key, query);
            }
        });
    },
    get(url, key) {
        const params = url.getAll(key);
        if (!params || !Array.isArray(params) || !params.length) {
            return;
        }
        const out = [];
        params.forEach(item => {
            const val = parser.parse(item);
            if (val !== undefined) {
                out.push(val);
            }
        });
        return out;
    },
});
export class QueryParamsHandler {
    constructor(handlers) {
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: handlers
        });
    }
    static from(handlers) {
        return new QueryParamsHandler(handlers);
    }
    toString(params) {
        const keys = Object.keys(this.handlers);
        const url = new URLSearchParams();
        keys.forEach(key => {
            const handler = this.handlers[key];
            const val = params[key];
            if (handler && val !== undefined && val !== null) {
                handler.set(url, key, val);
            }
        });
        return url.toString();
    }
    parse(query) {
        const url = new URLSearchParams(query !== null && query !== void 0 ? query : '');
        const keys = Object.keys(this.handlers);
        return keys.reduce((acc, key) => {
            const handler = this.handlers[key];
            if (!handler) {
                return acc;
            }
            const val = handler.get(url, key);
            if (val === undefined) {
                return acc;
            }
            return Object.assign(Object.assign({}, acc), { [key]: val });
        }, {});
    }
}
Object.defineProperty(QueryParamsHandler, "parserString", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: querySingleParam(paramParsers.uri)
});
Object.defineProperty(QueryParamsHandler, "parserNumber", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: querySingleParam(paramParsers.number)
});
Object.defineProperty(QueryParamsHandler, "parserDate", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: querySingleParam(paramParsers.date)
});
Object.defineProperty(QueryParamsHandler, "parserBoolean", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: querySingleParam(paramParsers.bool)
});
Object.defineProperty(QueryParamsHandler, "parserNumberArray", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: queryArrayParam(paramParsers.number)
});
Object.defineProperty(QueryParamsHandler, "parserStringArray", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: queryArrayParam(paramParsers.uri)
});
Object.defineProperty(QueryParamsHandler, "querySingleParam", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: querySingleParam
});
Object.defineProperty(QueryParamsHandler, "queryArrayParam", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: queryArrayParam
});
//# sourceMappingURL=query-params-handler.js.map